import * as authApi from '@/api/auth'
import { setSession, removeToken } from '@/utils/auth'

const state = {
  user: null,
  isLoggedIn: false,
}

const getters = {
  isLoggedIn: (state) => state.isLoggedIn,
  user: (state) => state.user,
  role: (state) => state.user?.level || null,
}

const actions = {
  async login({ commit }, credentials) {
    const { data } = await authApi.login(credentials)
    const { user, token, refresh_token: refreshToken } = data.data

    setSession({ token, refreshToken, role: user.level })
    commit('SET_USER', user)
    return data
  },

  async register(_, payload) {
    const { data } = await authApi.register(payload)
    return data
  },

  async logout({ commit }) {
    removeToken()
    commit('RESET_USER')
  },
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
    state.isLoggedIn = true
  },
  RESET_USER(state) {
    state.user = null
    state.isLoggedIn = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
